<template>
  <div class="flex w-60 max-h-80 flex-col gap-2 overflow-auto">
    <button
      v-for="option in dynamicDateOptions"
      :key="option.label"
      class="rounded-sm border px-4 py-2 text-center text-xs font-semibold w-60 h-14 min-w-60 max-w-60 min-h-14 max-h-14"
      :class="
        selectedDynamicDate === option.value
          ? 'selected-date-picker-button'
          : 'date-picker-button'
      "
      @click="selectedDynamicDate = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>
<script setup lang="ts">
import { type PropType, computed } from "vue";

import type { DynamicDateOption } from "@/models/datePicker";

const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  dynamicDateOptions: {
    type: Array as PropType<DynamicDateOption[]>,
    required: true,
  },
});

const emit = defineEmits<{
  "update:modelValue": [dynamicDate: string];
}>();

const selectedDynamicDate = computed({
  get() {
    return props.modelValue;
  },
  set(dynamicDate: string) {
    emit("update:modelValue", dynamicDate);
  },
});
</script>
